import React, { useState } from 'react';
import './home-categories.css';
import Common_title from '../../common-components/common-title/Common_title';
import { Link } from 'react-router-dom';

const Categories = () => {
    const allcategory = [
        { catname: "Fresh Fruits", catimg: "/assets/images/home/category/fruits.png" },
        { catname: "Fresh Vegitables", catimg: "/assets/images/home/category/vegitable.png" },
        // { catname: "Baby Care", catimg: "/assets/images/home/category/babycare.jpg" },
        // { catname: "Kitchen Essentials", catimg: "/assets/images/home/category/kitchen.jpg" },
        // { catname: "Weight Management", catimg: "/assets/images/home/category/weight.jpg" },
        // { catname: "Pregnancy & Women Wellness", catimg: "/assets/images/home/category/pregnancy.jpg" },
        // { catname: "Heart & Blood Pressure Care", catimg: "/assets/images/home/category/5.png" },
    ];

    const [showAll, setShowAll] = useState(false);

    const displayedCategories = showAll ? allcategory : allcategory.slice(0, 5);

    return (
        <section className='home_categories_sec'>
            <div className='container'>
                <Common_title title="Category" subtitle="What we’re offering to customers" />
                <div className='all-category'>
                    <div className="row justify-content-center">
                        {displayedCategories.map((data, index) => (
                            <div className="col-md-3 col-6" key={index}>
                                <Link target="_blank" to="https://play.google.com" >
                                    <div className='cat_div'>
                                        <div className='img_div'>
                                            <img className='catimg' src={process.env.PUBLIC_URL + data.catimg} alt='category-img' />
                                        </div>
                                        <div className='contbox'>
                                            <p className='catname'>{data.catname}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* Toggle View More/View Less button */}
                    {/* <div className="view-more-btn-wrapper" style={{ textAlign: 'center', marginTop: '30px' }}>
                        <button
                            className="view-more-btn"
                            onClick={() => setShowAll(!showAll)}
                        >
                            {showAll ? 'View Less' : 'View More'}
                        </button>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Categories;